import { render, staticRenderFns } from "./CategorySortsLoading.vue?vue&type=template&id=97888c4e&scoped=true&name=the-sorts-skeleton&"
import script from "./CategorySortsLoading.vue?vue&type=script&lang=js&"
export * from "./CategorySortsLoading.vue?vue&type=script&lang=js&"
import style0 from "./CategorySortsLoading.vue?vue&type=style&index=0&id=97888c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97888c4e",
  null
  
)

export default component.exports